export default __webpack_public_path__ + "static/media/contactus.734c2ad6.jpg";